import { useEffect } from "react";
import { useMapEvents } from "react-leaflet";

/** Adds map-zoom-lg / map-zoom-xl classes to the map container so CSS can
 *  scale label text up as members zoom in. */
export default function ZoomLabelScaler() {
  const map = useMapEvents({ zoomend: apply });

  function apply() {
    const z = map.getZoom();
    const el = map.getContainer();
    el.classList.toggle("map-zoom-lg", z >= 10 && z < 12);
    el.classList.toggle("map-zoom-xl", z >= 12);
  }

  useEffect(() => {
    apply();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
}
